var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVimeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1368_1494)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1368_1494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#41B1DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.129 8.20084C19.148 8.91754 19.0021 9.58351 18.7548 10.2241C18.3235 11.3404 17.6956 12.3425 17.0042 13.3066C16.0465 14.6385 15.0444 15.9387 13.7759 17.0042C13.1544 17.5243 12.4884 17.9619 11.6702 18.1268C11.1057 18.241 10.6237 18.0888 10.2241 17.6956C9.6533 17.1311 9.32349 16.4271 9.1015 15.666C8.69558 14.2516 8.32137 12.8245 7.92814 11.4101C7.80129 10.9408 7.64272 10.4841 7.4144 10.0529C7.36366 9.96406 7.31292 9.86892 7.25583 9.78647C6.91968 9.28541 6.69135 9.23467 6.17761 9.55179C5.99368 9.66596 5.81609 9.78647 5.6385 9.90697C5.54336 9.97674 5.47993 9.97674 5.40382 9.87526C5.2516 9.66596 5.0867 9.45666 4.92179 9.2537C4.85837 9.17124 4.83934 9.10782 4.93448 9.03171C5.94294 8.18181 6.85626 7.21141 7.94716 6.463C8.3404 6.19027 8.759 5.96194 9.2664 5.98097C9.78015 6 10.1861 6.2093 10.4842 6.62156C10.8267 7.09091 10.9725 7.63636 11.0613 8.20084C11.277 9.49471 11.4482 10.7949 11.778 12.0698C11.8859 12.4947 12.0127 12.9133 12.2283 13.3002C12.4947 13.7696 12.7801 13.833 13.148 13.4397C13.9408 12.5962 14.537 11.6194 14.9176 10.5222C15 10.2812 15.0127 10.0211 15 9.76744C14.9746 9.27907 14.6956 8.98731 14.2072 8.94926C13.8711 8.92389 13.5412 8.97463 13.2178 9.08245C13.0719 9.13319 13.0021 9.10782 13.0592 8.93023C13.37 8.01057 13.8076 7.16702 14.5941 6.55814C15.5138 5.84144 16.573 5.66385 17.6892 5.92389C18.5455 6.1205 18.907 6.78647 19.0529 7.59196C19.0909 7.80761 19.1036 8.01691 19.129 8.20084Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1368_1494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1368_1494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.6e84a33373f53412b54c481b8c776071.svg";
export { ForwardRef as ReactComponent };